import React, { ReactNode } from 'react';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';

import { useOpalUser } from '@frontend/hooks';

import { OPTIMIZELY_SDK_KEY } from '../envConfig';
// Initialize Optimizely client once
const optimizelyClient = createInstance({ sdkKey: OPTIMIZELY_SDK_KEY });

type FeatureFlagProviderProps = {
  children: ReactNode;
};

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({ children }) => {
  const { opalUser } = useOpalUser();
  return (
    <OptimizelyProvider
      optimizely={optimizelyClient}
      user={{
        id: opalUser?.id,
        attributes: {
          email: opalUser?.email,
          instanceId: opalUser?.instance.instance_id,
          customerId: opalUser?.instance.customer_id,
          productSku: opalUser?.instance.product_sku,
          productId: opalUser?.instance.product_id,
        },
      }}
    >
      {children}
    </OptimizelyProvider>
  );
};
